const operationalYuanAmountArr = [
  {
    label: '结算费用(元)',
    value: 'operationalYuanAmount',
    align: 'right'
  }
]
const opt = [
  {
    label: '操作',
    value: 'opt',
    fixed: 'right',
    fixWidth: '210px'
  }
]
//调查员：问卷调查 - 按答卷数量
export const column1 = [
  {
    label: '答卷ID',
    value: 'originId'
    // width: 60,
  },
  {
    label: '调查时间',
    value: 'investigateTime'
    // width: 60,
  },
  {
    label: '审核员',
    value: 'assessorName'
    // width: 60,
  },
  {
    label: '审核时间',
    value: 'assessTime'
    // width: 60,
  },
  {
    label: '单价(元)',
    value: 'maxUnitPriceYuan',
    align: 'right'
    // width: 60,
  },
  {
    label: '到手金额(元)',
    value: 'expectedYuanAmount',
    align: 'right'
    // width: 60,
  },
  ...opt
]
//代理：问卷调查 - 按答卷数量
export const column1_p = column1.slice(0, 5).concat(operationalYuanAmountArr, column1.slice(6))
//调查员：问卷调查 - 按天，问卷调查 - 按阶梯
export const column2 = [
  {
    label: '调查日期',
    value: 'investigateDateStr'
    // width: 60,
  },
  {
    label: '执行时间',
    value: 'time'
    // width: 150,
  },
  {
    label: '答卷数量',
    value: 'itemNum',
    align: 'right'
    // width: 60,
  },
  {
    label: '单价(元)',
    value: 'maxUnitPriceYuan',
    align: 'right'
    // width: 60,
  },
  {
    label: '到手金额(元)',
    value: 'expectedYuanAmount',
    align: 'right'
    // width: 60,
  },
  ...opt
]
//代理：问卷调查 - 按天，问卷调查 - 按阶梯
export const column2_p = column2.slice(0, 4).concat(operationalYuanAmountArr, column1.slice(5))
//调查员：明察暗访 - 按点位
export const column3 = [
  {
    label: '点位',
    value: 'area'
    // width: 60,
  },
  {
    label: '案件数',
    value: 'itemNum',
    align: 'right'
    // width: 100,
  },
  {
    label: '调查时间',
    value: 'investigateStartTime'
    // width: 120,
  },
  {
    label: '单价(元)',
    value: 'maxUnitPriceYuan',
    align: 'right'
    // width: 150
  },
  {
    label: '到手金额(元)',
    value: 'expectedYuanAmount',
    align: 'right'
    // width: 150
  },
  ...opt
]
//代理：明察暗访 - 按点位
export const column3_p = column3.slice(0, 4).concat(operationalYuanAmountArr, column1.slice(5))

//调查员：明察暗访 - 按阶梯计价
export const column4 = [
  {
    label: '调查日期',
    value: 'investigateDateStr'
    // width: 60,
  },
  {
    label: '执行时间',
    value: 'time',
    width: 150
  },
  {
    label: '案件数',
    value: 'itemNum',
    align: 'right'
    // width: 100,
  },
  {
    label: '关联点位',
    value: 'areaNum',
    align: 'right'
    // width: 100,
  },
  {
    label: '单价(元)',
    value: 'maxUnitPriceYuan',
    align: 'right'
    // width: 150
  },
  {
    label: '到手金额(元)',
    value: 'expectedYuanAmount',
    align: 'right'
    // width: 150
  },
  ...opt
]
//代理：明察暗访 - 按阶梯计价
export const column4_p = column4.slice(0, 5).concat(operationalYuanAmountArr, column1.slice(6))
//调查员：明察暗访 - 按天
export const column5 = [
  {
    label: '调查日期',
    value: 'investigateDateStr'
    // width: 60,
  },
  {
    label: '执行时间',
    value: 'time',
    width: 150
  },
  {
    label: '案件数',
    value: 'itemNum',
    align: 'right'
    // width: 100,
  },
  {
    label: '关联点位',
    value: 'areaNum',
    align: 'right'
    // width: 100,
  },
  {
    label: '单价(元)',
    value: 'maxUnitPriceYuan',
    align: 'right'
    // width: 150
  },
  {
    label: '金额(元)', //?
    value: 'expectedYuanAmount',
    align: 'right'
    // width: 150
  },
  ...opt
]
//代理：明察暗访 - 按天
export const column5_p = column5.slice(0, 5).concat(operationalYuanAmountArr, column1.slice(6))
//调查员：人工导入
export const column6 = [
  {
    label: '结算方式',
    value: 'settleMode'
    // width: 60,
  },
  {
    label: '数量',
    value: 'unitQuantity'
    // width: 100,
  },
  {
    label: '单价(元)',
    value: 'maxUnitPriceYuan',
    align: 'right'
    // width: 150
  },
  {
    label: '到手金额(元)',
    value: 'expectedYuanAmount',
    align: 'right'
    // width: 150
  },
  ...opt
]
//代理：人工导入
export const column6_p = column6.slice(0, 3).concat(operationalYuanAmountArr, ...opt)
